<template>
  <div class="demo">
    <div id="demo"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie';

export default {
  name: 'Demo',
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('demo'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/saving_money/animations/instructions_demo.json',
    });
  },
};
</script>

<style lang="scss" scoped>
.demo {
  bottom: 2vh;
  height: 60vh;
  position: absolute;
  width: 60vh;
}

#demo {
  // bottom: 2vh;
  height: 100%;
  // position: absolute;
  width: 100%;
}
</style>
